module.exports = "img/warning.24ba73b.png";